import React from 'react';
import './style.css'


class FooterComponent extends React.Component {  
    render() {
            return (
       <>
        <footer className="rodape" id="contato">
      
    <div className="align">


    <ul className="lista-rodape">
    
        <a href="https://www.linkedin.com/in/maria-estela-souza-737ab216a/" target="_blank"><img className="tam-img-rodape img-fluid" src="https://cin.ufpe.br/~mecls/img/linkedin.png"/></a>
      
    
        <a href="https://www.instagram.com/estelasouza/" target="_blank"><img className="tam-img-rodape img-fluid" src="https://cin.ufpe.br/~mecls/img/insta.png"/></a>
      
    
        <a href="https://github.com/estelasouza" target="_blank"><img className="tam-img-rodape img-fluid" src="https://cin.ufpe.br/~mecls/img/git.png"/></a>
       
    </ul>
    <p className="text-design "> Design by <a target="_blank" href="https://github.com/ddevdan">Dan ♥  </a> to Maria Estela Souza</p>
    </div>

  </footer>
        </>
        )}
  
}

export default FooterComponent;
